import { useQuery } from '@tanstack/react-query';
import { NOTIFICATION_POPUP_LIST } from 'src/constants/queryKeys';
import axiosInstance from 'src/utils/axios';

export const networkGetNotificationPopupInfo = async (id) => {
  const res = await axiosInstance.post(`NotificationPopup/Info/${id}`);
  return res;
};

export const networkGetNotificationPopupList = async (projectId, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`NotificationPopup/List/${projectId}/1/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchNotificationPopupList(projectId, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [NOTIFICATION_POPUP_LIST, projectId, pageIndex],
    queryFn: () => networkGetNotificationPopupList(projectId, pageIndex, pageSize),
  });
}

export const networkUpdateNotificationPopup = async (id, data) => {
  const res = await axiosInstance.post(`NotificationPopup/Update/${id}`, data);
  return res;
};

export const networkRemoveNotificationPopup = async (id) => {
  const res = await axiosInstance.post(`NotificationPopup/Remove/${id}`);
  return res;
};

export const networkCreateNotificationPopup = async (data) => {
  const res = await axiosInstance.post('NotificationPopup/Insert', data);
  return res;
};

// ----------------------------------------------------------------------------

const networkNotificationPopupTypeList = async () => {
  const res = await axiosInstance.post('NotificationPopupType/List');
  return res;
};

export function useFetchNotificationPopupTypeList() {
  return useQuery({
    queryKey: ['NOTIFICATION_POPUP_TYPE_LIST'],
    queryFn: () => networkNotificationPopupTypeList(),
  });
}

const networkNotificationPopupValueTypeList = async () => {
  const res = await axiosInstance.post('NotificationBannerValueType/List');
  return res;
};

export function useFetchNotificationPopupValueTypeList() {
  return useQuery({
    queryKey: ['NOTIFICATION_BANNER_VALUE_TYPE_LIST'],
    queryFn: () => networkNotificationPopupValueTypeList(),
  });
}

const networkNotificationPopupCloseModeList = async () => {
  const res = await axiosInstance.post('NotificationBannerCloseMode/List');
  return res;
};

export function useFetchNotificationPopupCloseModeList() {
  return useQuery({
    queryKey: ['NOTIFICATION_POPUP_CLOSE_MODE'],
    queryFn: () => networkNotificationPopupCloseModeList(),
  });
}

const networkNotificationPopupLinkTypeList = async () => {
  const res = await axiosInstance.post('NotificationBannerLinkType/List');
  return res;
};

export function useFetchNotificationPopupLinkTypeList() {
  return useQuery({
    queryKey: ['NOTIFICATION_POPUP_LINK_TYPE_LIST'],
    queryFn: () => networkNotificationPopupLinkTypeList(),
  });
}
